export const immutableMove = (array, from, to) => {
  const copy = [...array]
  if (to >= copy.length) {
    let k = to - copy.length - 1
    while (k + 1) {
      copy.push(undefined)
      k -= 1
    }
  }
  copy.splice(to, 0, copy.splice(from, 1)[0])
  return copy
}

export const chunk = (arr, n) => {
  const result = []
  let i = 0
  while (i < arr.length / n) {
    result.push(arr.slice(i * n, i * n + n))
    i += 1
  }

  return result
}

export const range = (n1, n2) => {
  const result = []
  let first = !n2 ? 0 : n1
  let last = n2

  if (!last) {
    last = n1
  }

  while (first < last) {
    result.push(first)
    first += 1
  }
  return result
}

export const repeat = (el, n) => range(n).map(() => el)

export const findIndex = (lst, predicate) => {
  let i = 0
  while (i < lst.length) {
    if (predicate(lst[i])) {
      return i
    }
    i += 1
  }
  return -1
}
